// MCQTopBar.jsx
import React, { useEffect } from "react";
import { useState } from "react";
import "./MCQProblem.css";


export default function MCQProblem(
    {   problemDescription, mcqOptions, numSolutions, indexOfSelectedMCQProblem, setIndexOfSelectedMCQProblem, 
        numProblems, updateSolutionAt, userSolutions, setCorrectAt, option_selected, set_option_selected, isProblemCorrect
    }) {
    

    const mcqOptionsList = mcqOptions.map((option, index) => {

        const handleClickOnOption = () => {
            const currentSelection = userSolutions[indexOfSelectedMCQProblem];
            const newSelection = currentSelection.includes(index)
              ? currentSelection.filter(i => i !== index)
              : [...currentSelection, index];
          
            updateSolutionAt(indexOfSelectedMCQProblem, newSelection);
            console.log("Curr state: ", isProblemCorrect[indexOfSelectedMCQProblem])
            if(isProblemCorrect[indexOfSelectedMCQProblem] !== "correct" && isProblemCorrect[indexOfSelectedMCQProblem] !== "incorrect"){
                setCorrectAt(indexOfSelectedMCQProblem, "selected")
            }
        }
        
        return (
            
            <li 
                onClick={handleClickOnOption}
                className="mcq-radio-button-list" key={index}
            >
                <div>
                    <input 
                        checked={userSolutions[indexOfSelectedMCQProblem].includes(index)}
                        className="mcq-radio-button" 
                        type={numSolutions > 1 ? "checkbox": "radio"}
                    />
                    {option}
                </div>
            </li>

        );
    })


    return(


        <>
            <div className="mcq-wrapper"> 
                <div className="text-box" >
                    
                    <div className='mcq-top-bar-options-container'>
                        <button className='mcq-option problem ' onClick={() => set_option_selected("Problem")}>
                                <svg
                                    className='problem-svg'
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18" height="18"
                                    viewBox="0 0 512 560"
                                    role="img"
                                    aria-labelledby="problemIconTitle"
                                >
                                    <title id="problemIconTitle">Problem Icon</title>
                                    <rect x="16" y="16" width="480" height="525" rx="64" fill="none"
                                            stroke="#616161" stroke-width="32"/>
                                    <g stroke="#b3b1b1" stroke-width="30" stroke-linecap="round">
                                        <line x1="144" y1="120" x2="304" y2="120"/>
                                        <line x1="224" y1="136" x2="224" y2="296"/>
                                        <line x1="336" y1="160" x2="448" y2="160"/>
                                        <line x1="336" y1="224" x2="448" y2="224"/>
                                        <line x1="336" y1="288" x2="448" y2="288"/>
                                        <line x1="128" y1="352" x2="384" y2="352"/>
                                        <line x1="128" y1="416" x2="384" y2="416"/>
                                        <line x1="128" y1="480" x2="384" y2="480"/>
                                    </g>
                                </svg>
                            <div className='text-wrapper'>Problem</div>  
                        </button>

                        <button className='mcq-option video' onClick={() => set_option_selected("Video")}>
                                <svg 
                                    className='camera-svg'
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24" height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#ff3030bf"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round">
                                <rect x="2" y="6" width="14" height="12" rx="2" ry="2"/>
                                <path d="M16 8 L22 6 L22 18 L16 16"/>
                                </svg>

                                <div className='text-wrapper'>Video</div>
                        </button >

                        <button
                            className="mcq-option code"
                            onClick={() => set_option_selected("Solution")}
                            style={{ display: "flex", alignItems: "center" }}
                        >
                        <svg
                            className="solution-svg"
                            xmlns="http://www.w3.org/2000/svg"
                            width="1.2em"
                            height="1.2em"
                            viewBox="0 0 24 24"
                            aria-label="lightbulb"
                            role="img"
                            fill="none"
                            style={{ flexShrink: 0 }}
                        >
                            <path
                                d="M12 2a7 7 0 00-7 7c0 2.757 1.657 5.116 4 6.164V17a1 1 0 001 1h4a1 1 0 001-1v-1.836c2.343-1.048 4-3.407 4-6.164a7 7 0 00-7-7z"
                                fill="#FFEB3B"
                                stroke="currentColor"
                                strokeWidth="0.5"
                                />
                                <path
                                d="M10 14h4v1a1 1 0 01-1 1h-2a1 1 0 01-1-1v-1zM9 11a3 3 0 016 0"
                                stroke="#555"
                                strokeWidth="1"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                fill="none"
                            />
                            <rect x="9" y="17" width="6" height="3" rx="1" fill="#B0AFAF" />
                            <line x1="9" y1="18" x2="15" y2="18" stroke="#8C8A8A" strokeWidth="0.5" />
                            <line x1="9" y1="19" x2="15" y2="19" stroke="#8C8A8A" strokeWidth="0.5" />
                        </svg>
                        <div className="solution-text-wrapper">
                            Solution
                        </div>
                        </button>
                    </div>

                    <div className="mcq-text-wrapper">
                        {problemDescription}
                    </div>

                </div>           

                {
                    option_selected === "Problem" && 

                 
                    
                    <div className="mcq-options-list-container">
                        
                        <button className={`mcq-problem-arrow ${indexOfSelectedMCQProblem === 0 ? 'is-invisible' : ''}`}
                            onClick={() =>{
                                if (indexOfSelectedMCQProblem > 0) {
                                    setIndexOfSelectedMCQProblem(indexOfSelectedMCQProblem - 1)
                                }
                            }}
                        >
                            &lt;
                        </button>
                        
                        <ul className="mcq-option-list">
                            {mcqOptionsList}
                        </ul>
                            <button className={`mcq-problem-arrow ${indexOfSelectedMCQProblem === numProblems - 1 ? 'is-invisible' : ''}`}
                                onClick={() =>{
                                    if (indexOfSelectedMCQProblem < numProblems-1) {
                                        setIndexOfSelectedMCQProblem(indexOfSelectedMCQProblem + 1)
                                    }
                                }}
                            >
                                &gt;
                            </button>
                    </div>
                }
            </div>

  
        </>

    );
}